module.exports = __webpack_public_path__ + "media/about/sandy-789a028d.jpg";